import React from 'react';

import { appAuthenticator } from '@futrli/shared-services';

import { signOut } from '../../login/redux-utils/actions';
import { StorageBackedNumber } from '../storage';

interface Props {
  sessionDurationMs: number;
  lastActivityStorage: StorageBackedNumber;
  signOut: typeof signOut;
}

/**
 * SessionTimeoutManager
 *
 * This component is responsible for keeping track of any session activity (as
 * determined by the global `authenticator`) and ensuring we automatically
 * sign-out a user after a period of inactivity.
 *
 * In the near future it should also notify a user that their session will
 * expire soon and offer a way to continue.
 *
 * It is only expected to be mounted in an authenticated context.
 */
export class SessionTimeoutManager extends React.Component<Props> {

  /* eslint-disable no-magic-numbers */
  private pollFrequencyMs = 10000;
  private initialActivity = Date.now();

  private timerId?: number;

  public componentDidMount(): void {
    this.timerId = window.setInterval(this.checkSessionDuration, this.pollFrequencyMs);

    this.checkSessionDuration();
  }

  public componentWillUnmount(): void {
    window.clearInterval(this.timerId);
  }

  public render(): JSX.Element | null {
    return null;
  }

  private checkSessionDuration = () => {
    const lastSessionActivity: number = appAuthenticator.getLastSessionActivity() || this.initialActivity;

    this.props.lastActivityStorage.setVal(lastSessionActivity);

    if (lastSessionActivity + this.props.sessionDurationMs < Date.now()) {
      this.props.signOut();
      this.props.lastActivityStorage.setVal(null);
    }
  }
}
